/**
 * Livewire-driven modal (the `<x-ui.modal.index>` component). `isOpen` is entangled with the
 * component's `wire:model`, so the server and the browser share one open state.
 *
 * Open or close it from anywhere by dispatching `modal-open` / `modal-close` with `{ id }`.
 *
 * @param {{ id: string, isOpen: boolean, staticBackdrop?: boolean, closeOnEscape?: boolean }} config
 *        `isOpen` must be passed through untouched so Livewire's entangle binding survives.
 */
export default function uiModal({ id, isOpen, staticBackdrop = false, closeOnEscape = true }) {
    return {
        id,
        isOpen,
        staticBackdrop,
        closeOnEscape,
        isSubmitting: false,

        init() {
            this.$watch('isOpen', (open) => (open ? this.onOpen() : this.onClose()));

            if (this.isOpen) {
                this.onOpen();
            }
        },

        destroy() {
            this.onClose();
        },

        open() {
            this.isOpen = true;
        },

        close() {
            this.isOpen = false;
        },

        cancel() {
            this.$dispatch('modal-cancelled', { id: this.id });
            this.close();
        },

        onOpen() {
            document.body.classList.add('modal-open');
            this.$dispatch('modal-opened', { id: this.id });
        },

        onClose() {
            const hasOpenDialog = document.querySelector("[role='dialog'][aria-hidden='false']") !== null;

            if (!hasOpenDialog) {
                document.body.classList.remove('modal-open');
            }

            this.$dispatch('modal-closed', { id: this.id });
        },
    };
}
